/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../../../types/definitions/vendor/graphql-schema.d";
import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetLookbookPreviousLooksQueryVariables = Types.Exact<{
  page: Types.Scalars["Int"]["input"];
}>;
export type GetLookbookPreviousLooksQuery = {
  __typename?: "Query";
  client?: {
    __typename?: "Client";
    vision: {
      __typename?: "Vision";
      id: string;
      previousLooks?: {
        __typename?: "LookConnection";
        pageInfo: {
          __typename?: "PageInfo";
          hasNextPage: boolean;
          endCursor?: string | null;
        };
        nodes: Array<{
          __typename?: "Look";
          id: string;
          image: {
            __typename?: "Image";
            baseUrl: string;
            mediaPath: string;
            altText: string;
          };
        }>;
      } | null;
    };
  } | null;
};
export const GetLookbookPreviousLooksDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "getLookbookPreviousLooks"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "page"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "Int"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "client"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "vision"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "id"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "previousLooks"
                },
                arguments: [{
                  kind: "Argument",
                  name: {
                    kind: "Name",
                    value: "limit"
                  },
                  value: {
                    kind: "IntValue",
                    value: "12"
                  }
                }, {
                  kind: "Argument",
                  name: {
                    kind: "Name",
                    value: "page"
                  },
                  value: {
                    kind: "Variable",
                    name: {
                      kind: "Name",
                      value: "page"
                    }
                  }
                }],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "pageInfo"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "hasNextPage"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "endCursor"
                        }
                      }]
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "nodes"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "id"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "image"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "baseUrl"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "mediaPath"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "altText"
                            }
                          }]
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;

/**
 * __useGetLookbookPreviousLooksQuery__
 *
 * To run a query within a React component, call `useGetLookbookPreviousLooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLookbookPreviousLooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLookbookPreviousLooksQuery({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetLookbookPreviousLooksQuery(baseOptions: Apollo.QueryHookOptions<GetLookbookPreviousLooksQuery, GetLookbookPreviousLooksQueryVariables> & ({
  variables: GetLookbookPreviousLooksQueryVariables;
  skip?: boolean;
} | {
  skip: boolean;
})) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useQuery<GetLookbookPreviousLooksQuery, GetLookbookPreviousLooksQueryVariables>(GetLookbookPreviousLooksDocument, options);
}
export function useGetLookbookPreviousLooksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLookbookPreviousLooksQuery, GetLookbookPreviousLooksQueryVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useLazyQuery<GetLookbookPreviousLooksQuery, GetLookbookPreviousLooksQueryVariables>(GetLookbookPreviousLooksDocument, options);
}
// @ts-ignore
export function useGetLookbookPreviousLooksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLookbookPreviousLooksQuery, GetLookbookPreviousLooksQueryVariables>): Apollo.UseSuspenseQueryResult<GetLookbookPreviousLooksQuery, GetLookbookPreviousLooksQueryVariables>;
export function useGetLookbookPreviousLooksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLookbookPreviousLooksQuery, GetLookbookPreviousLooksQueryVariables>): Apollo.UseSuspenseQueryResult<GetLookbookPreviousLooksQuery | undefined, GetLookbookPreviousLooksQueryVariables>;
export function useGetLookbookPreviousLooksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLookbookPreviousLooksQuery, GetLookbookPreviousLooksQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useSuspenseQuery<GetLookbookPreviousLooksQuery, GetLookbookPreviousLooksQueryVariables>(GetLookbookPreviousLooksDocument, options);
}
export type GetLookbookPreviousLooksQueryHookResult = ReturnType<typeof useGetLookbookPreviousLooksQuery>;
export type GetLookbookPreviousLooksLazyQueryHookResult = ReturnType<typeof useGetLookbookPreviousLooksLazyQuery>;
export type GetLookbookPreviousLooksSuspenseQueryHookResult = ReturnType<typeof useGetLookbookPreviousLooksSuspenseQuery>;
export type GetLookbookPreviousLooksQueryResult = Apollo.QueryResult<GetLookbookPreviousLooksQuery, GetLookbookPreviousLooksQueryVariables>;